import { ChamberFaultStatus } from './chamberFaultStatus';
import { ChamberFloodStatus } from './chamberFloodStatus';
import { ChamberMaintenanceStatus } from './chamberMaintenanceStatus';

export enum SiteStatus {
  ok,
  warning,
  spill,
  quiet,
}

export enum InvestigationStatus {
  new,
  ongoing,
  cleared,
  maintenance,
}

export enum FaultStatus {
  none,
  noLogger,
  noValidChannel,
  noValidAlarmConfiguration,
}

export const FloodSiteStatus = new Map<ChamberFloodStatus, SiteStatus>([
  [ChamberFloodStatus.Unknown, SiteStatus.ok],
  [ChamberFloodStatus.WaterIncreasing, SiteStatus.warning],
  [ChamberFloodStatus.Flood, SiteStatus.spill],
  [ChamberFloodStatus.WaterLowering, SiteStatus.ok],
]);

export const InvestigationSiteStatus = new Map<
  ChamberMaintenanceStatus,
  InvestigationStatus
>([
  [
    ChamberMaintenanceStatus.MaintenanceRequired,
    InvestigationStatus.maintenance,
  ],
  [ChamberMaintenanceStatus.Unknown, InvestigationStatus.new],
  [ChamberMaintenanceStatus.New, InvestigationStatus.new],
  [ChamberMaintenanceStatus.Ongoing, InvestigationStatus.ongoing],
  [ChamberMaintenanceStatus.Cleared, InvestigationStatus.cleared],
]);

export const SiteMaintenanceStatus = new Map<
  InvestigationStatus,
  ChamberMaintenanceStatus
>([
  [
    InvestigationStatus.maintenance,
    ChamberMaintenanceStatus.MaintenanceRequired,
  ],
  [InvestigationStatus.new, ChamberMaintenanceStatus.New],
  [InvestigationStatus.ongoing, ChamberMaintenanceStatus.Ongoing],
  [InvestigationStatus.cleared, ChamberMaintenanceStatus.Cleared],
]);

export const SiteFaultStyleClass = 'fault';
export const SiteFaultDescription = new Map<FaultStatus, string>([
  [FaultStatus.none, ''],
  [FaultStatus.noLogger, 'Device missing'],
  [FaultStatus.noValidChannel, 'Channel missing'],
  [FaultStatus.noValidAlarmConfiguration, 'Alarms missing'],
]);

export const FaultSiteStatus = new Map<ChamberFaultStatus, FaultStatus>([
  [ChamberFaultStatus.None, FaultStatus.none],
  [ChamberFaultStatus.NoLogger, FaultStatus.noLogger],
  [ChamberFaultStatus.NoValidChannel, FaultStatus.noValidChannel],
  [
    ChamberFaultStatus.NoValidAlarmConfiguration,
    FaultStatus.noValidAlarmConfiguration,
  ],
]);

export type PipeType = 'WasteFoulPipe' | 'WasteSurfacePipe';

export const PipeType = {
  WasteFoulPipe: 'WasteFoulPipe' as PipeType,
  WasteSurfacePipe: 'WasteSurfacePipe' as PipeType,
};

export enum PipesVisibility {
  show = 'show',
  hide = 'hide',
}

export enum ChamberFilterOptions {
  all = 'All events',
  ok = 'Ok',
  warning = 'Warning',
  spill = 'Spill',
  quiet = 'Quiet',
  faulted = 'Faulted',
  investigation = 'Investigation',
  cleared = 'Cleared',
  maintenance = 'Maintenance Required',
  last24h = 'Event in last 24h',
}

export enum MaintenanceDuration {
  Day = 'Day',
  Week = 'Week',
  Month = 'Month',
  Quarter = '3 Months',
  HalfYear = '6 Months',
  Year = 'Year',
}

export enum MaintenanceEntryType {
  Note = 'Note',
  MaintenanceChange = 'MaintenanceChange',
}
